module.exports = __webpack_public_path__ + "src/assets/blue-lion-dance1.jpg";